import { IModuleMetaData } from "./company-module";

export class ApiAccessMetaData {
	private metadata:IModuleMetaData;

	private constructor(metadata:IModuleMetaData){
		this.metadata = metadata;
	}

	public static create(metadata:IModuleMetaData):ApiAccessMetaData{
		return new ApiAccessMetaData(metadata || {});
	}

	public getMaxApiCalls():number{
		return parseInt(this.metadata["max-api-calls"] || "0") || 0;
	}

	public setMaxApiCalls(count:number):void {
		this.metadata["max-api-calls"] = `${count}`;
	}

	public getApiCallsUsed():number{
		return parseInt(this.metadata["api-calls-used"] || "0") || 0;
	}

	public setApiCallsUsed(count:number):void {
		this.metadata["api-calls-used"] = `${count}`;
	}

}